import { render, staticRenderFns } from "./MyAccountRoute.vue?vue&type=template&id=ec1e535e&"
import script from "./MyAccountRoute.vue?vue&type=script&lang=ts&"
export * from "./MyAccountRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports